import { render, staticRenderFns } from "./CamaraFqa.vue?vue&type=template&id=2a8a2e08&scoped=true"
import script from "./CamaraFqa.vue?vue&type=script&lang=js"
export * from "./CamaraFqa.vue?vue&type=script&lang=js"
import style0 from "./CamaraFqa.vue?vue&type=style&index=0&id=2a8a2e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a2e08",
  null
  
)

export default component.exports